import React, { FunctionComponent } from "react";

import { IStatistics, IStatisticsFields } from "@/types/generated/contentful";

type Props = {
  content: IStatistics;
};

const Statistics: FunctionComponent<Props> = ({ content }) => {
  const {
    heading,
    body,
    subText,
    textAlignment,
    background,
    foreground,
    foregroundBody,
  } = content.fields as IStatisticsFields;

  let textAlign = "text-left";
  switch (textAlignment) {
    case "center":
      textAlign = "text-center";
      break;
    case "right":
      textAlign = "text-right";
      break;
    default:
      textAlign = "text-left";
      break;
  }

  return (
    <div
      className={`mx-auto max-w-screen-xl rounded-xl ${!!background && "p-8"} ${textAlign}`}
      style={{
        backgroundColor: background || "transparent",
      }}
    >
      <div className="flex flex-col gap-2">
        <div
          className="text-6xl font-extrabold xl:text-7xl"
          style={{
            ...(foreground && { color: foreground }),
          }}
        >
          {heading}
        </div>
        {body && (
          <div
            className="text-xl font-medium xl:text-2xl"
            style={{
              ...(foregroundBody && { color: foregroundBody }),
            }}
          >
            {body}
          </div>
        )}
        {subText && (
          <div
            className="text-base"
            style={{
              ...(foregroundBody && { color: foregroundBody }),
            }}
          >
            {subText}
          </div>
        )}
      </div>
    </div>
  );
};

export default Statistics;
